<div
  class="input-container"
  [class.warning]="paymentAmountControl.invalid"
  [class.disabled]="disabled"
  [class.is-touch]="isTouch"
>
  <ng-container *ngIf="isTouch; else inputNoTouch">
    <ion-item class="ion-invalid" data-cy="amount-item">
      <ion-label>$</ion-label>
      <ng-container [ngTemplateOutlet]="paymentAmountInput"></ng-container>
      <ion-note *ngIf="paymentAmountControl.errors?.max" slot="error">
        {{ 'i18n.payments.adjustPayment.amountIsHigherError' | translate }}
      </ion-note>
      <ion-note *ngIf="paymentAmountControl.errors?.min" slot="error">
        {{ 'i18n.payments.adjustPayment.amountIsZeroError' | translate }}
      </ion-note>
    </ion-item>
  </ng-container>
  <ng-template #inputNoTouch>
    <span class="dollar-sign">$</span>
    <ng-container [ngTemplateOutlet]="paymentAmountInput"></ng-container>
  </ng-template>

  <ng-template #paymentAmountInput>
    <ion-input
      class="bold"
      customDecimal
      data-cy="edit-invoice-payment-amount-input"
      inputmode="decimal"
      [disabled]="disabled"
      [maxPrecision]="2"
      [value]="paymentAmount || 0 | number: '1.2-2'"
      (ionBlur)="updatePaymentAmount($event)"
    ></ion-input>
  </ng-template>
</div>
